import { SplitPageError } from "@/constants/splitPage";
import { FileSplitException } from "@/types/jobFileUpload/FileSplitException";

// Return type is reject promise
type SplitPageErrorHandlerReturnType = Promise<void>;
export const splitPageErrorHandler = (error: unknown): SplitPageErrorHandlerReturnType => {
  if (error instanceof FileSplitException) {
    throw error;
  }

  throw new FileSplitException(SplitPageError.PAGE_PROCESSING_FAILED, "Failed to process PDF");
};
